import { Typography } from '@mui/material';
import classNames from 'classnames';
import React, { FC } from 'react';
import { useStyles } from './DefaultText.styles';

type DefaultTextProps = Pick<
  React.ComponentProps<typeof Typography>,
  'color' | 'sx' | 'className' | 'style'
>;

export const DefaultText: FC<DefaultTextProps> = ({ children, className, ...rest }) => {
  const { classes } = useStyles();

  return (
    <Typography component="span" className={classNames(classes.root, className)} {...rest}>
      {children}
    </Typography>
  );
};
